import { render, staticRenderFns } from "./ProlongationCourse.vue?vue&type=template&id=448fddf9&lang=pug&"
import script from "./ProlongationCourse.vue?vue&type=script&lang=ts&"
export * from "./ProlongationCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports